import { useMemo } from 'react';

/**
 * Hook pentru gestionarea schemei dinamică din environment variables
 */
export const useSchema = () => {
  const schema = useMemo(() => {
    // Citirea schemei din environment variables
    const viteDbSchema = import.meta.env.VITE_DB_SCHEMA;
    const dbSchema = import.meta.env.DB_SCHEMA;
    
    // Schema finală cu fallback
    const finalSchema = viteDbSchema || dbSchema || 'public';
    
    return finalSchema;
  }, []);

  return {
    schema,
    isPublicSchema: schema === 'public',
    isClientSchema: schema.startsWith('clients_'),
    getSchemaHeader: () => ({ 'X-DB-Schema': schema })
  };
};
